export default __webpack_public_path__ + "static/media/icon-telecharger.4e20c307.svg";